"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconEvaluationVisit = function IconEvaluationVisit(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M35 24.66v-19H9v33l.005.217A5 5 0 0 0 14 43.66h21v-5h-2v3H14l-.176-.005A3 3 0 0 1 11 38.66V7.659h22v17zm-16-12h11v-1H19zm11 5H19v-1h11zm-11 5h11v-1H19zm22.194-2.003 4.182 4.257-11.053 11.108-4.895.708.677-4.918zm1.369 4.248-1.377-1.403-9.192 9.246-.223 1.622 1.605-.232zM17 22.16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5-3.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};

export { IconEvaluationVisit, IconEvaluationVisit as default };
